














import Vue from 'vue'

export default Vue.extend({
  name: 'TutorialDontShowAgain',

  props: {
    dontShowAgain: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    check () {
      this.$emit('check')
    },
  },
})
